import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledPrice = styled(Text)`
   color: ${({ theme }) => theme.placeholder};
`;
StyledPrice.displayName = 'StyledPrice';
